<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async(payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

    },
    methods:{
      
      filter: async function(){
         let responseTrucker = (await Request.do(this, 'POST', Request.getDefaultHeader(this), {fileName: "SystemUsers",collectionName: "system-users",filters:{status:"ACTIVE",type: "USER-CUSTOMER"}}, `${Endpoints.systemUsers.count}`)).data;
        
            this.total = responseTrucker.count;

        if (responseTrucker.status==200){
            this.chart.data.datasets[0].data = [responseTrucker.count];
            this.chart.update();  
        }
      }

    }
}
</script>
